<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="选择医院" prop="hospitalName">
                <a-input-search
                  v-model="queryParam.hospitalName"
                  placeholder="请选择医院"
                  enter-button="选择"
                  @search="handleSelectHospital"
                  :readonly="true"
                  allow-clear
                />
                <!-- 医院选择弹窗 -->
                <table-select-modal
                  :visible.sync="hospitalSelectVisible"
                  title="选择医院"
                  :width="1000"
                  :api-method="pageHospital"
                  :columns="hospitalColumns"
                  search-label="医院名称"
                  search-key="hospitalName"
                  search-placeholder="请输入医院名称"
                  :data-path="'data.records'"
                  :total-path="'data.total'"
                  @ok="handleHospitalSelected"
                  @cancel="handleHospitalCancel"
                >
                </table-select-modal>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="省份" prop="provinceId">
                <a-select
                  v-model="queryParam.provinceId"
                  placeholder="请选择省份"
                  allow-clear
                  @change="handleProvinceChange"
                >
                  <a-select-option v-for="item in provinceList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="城市" prop="cityId">
                <a-select
                  v-model="queryParam.cityId"
                  placeholder="请先选择省份"
                  allow-clear
                  :disabled="!queryParam.provinceId"
                >
                  <a-select-option v-for="item in cityList" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="科室名称" prop="departName">
                <a-input v-model="queryParam.departName" placeholder="请输入科室名称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="姓名" prop="name">
                <a-input v-model="queryParam.name" placeholder="请输入姓名" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="职称" prop="professional">
                <a-select v-model="queryParam.professional" placeholder="请选择职称" allow-clear>
                  <a-select-option v-for="item in dict.type['doctor_professional']" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <template v-if="advanced">

            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['doctor:doctor:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['doctor:doctor:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['doctor:doctor:remove']">
          <a-icon type="delete" />删除
        </a-button>

        <a-button type="primary" @click="handleImport" v-hasPermi="['doctor:doctor:import']">
          <a-icon type="upload" />导入
        </a-button>
        <!-- 同步华歧系数按钮（保持风格，增加选中状态提示） -->
        <a-button type="primary" @click="handleSyncScore" v-hasPermi="['doctor:doctor:syncScore']">
          <a-icon type="sync" />同步华歧系数
          <span v-if="selectedRowKeys.length > 0" class="selected-count">({{ selectedRowKeys.length }}条)</span>
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 导入弹窗 -->
      <a-modal
        title="导入"
        :visible="openUpload"
        :maskClosable="false"
        :confirm-loading="uploading"
        @cancel="importExcelHandleCancel"
        @ok="importExcelHandleChange"
      >
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">请将文件拖拽到此处上传❥(^_-)</p>
            <p class="ant-upload-hint">支持单个上传，也可以点击后选择文件上传</p>
          </a-upload-dragger>
          <a @click="importTemplate">下载模板</a>
        </a-spin>
      </a-modal>

      <!-- 加减分弹窗 -->
      <a-modal
        title="调整推荐分值"
        :visible="scoreModalVisible"
        :maskClosable="false"
        :confirm-loading="scoreLoading"
        @cancel="handleScoreModalCancel"
        @ok="handleScoreModalOk"
        width="400px"
      >
        <a-form :form="scoreForm" layout="vertical">
          <a-form-item label="医师姓名">
            <span>{{ currentDoctor?.name || '' }}</span>
          </a-form-item>
          <a-form-item label="当前分值">
            <span>{{ currentDoctor?.score || 0 }}</span>
          </a-form-item>
          <a-form-item
            label="调整分值"
            :validateStatus="scoreValidateStatus"
            :help="scoreValidateHelp"
          >
            <a-input-number
              v-model="changeScore"
              :min="-3000"
              :max="3000"
              :step="1"
              placeholder="请输入调整分值"
              style="width: 100%"
              @change="handleScoreInputChange"
            />
          </a-form-item>
          <a-form-item label="调整后分值">
            <span :style="{ color: (currentDoctor?.score || 0) + (changeScore || 0) < 0 ? 'red' : 'inherit' }">
              {{ (currentDoctor?.score || 0) + (changeScore || 0) }}
            </span>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- 同步华歧系数确认弹窗 -->
      <a-modal
        title="同步华歧系数"
        :visible="syncScoreModalVisible"
        :maskClosable="false"
        :confirm-loading="syncScoreLoading"
        @cancel="handleSyncScoreCancel"
        @ok="handleSyncScoreConfirm"
        width="400px"
      >
        <div style="padding: 20px 0; line-height: 1.6;">
          <!-- 根据选中状态显示不同提示文案 -->
          <p v-if="selectedRowKeys.length > 0">
            确认要同步选中的 {{ selectedRowKeys.length }} 位医师的华歧系数吗？
          </p>
          <p v-else>
            确认要同步所有医师的华歧系数吗？
          </p>
          <p style="color: #faad14; margin-top: 8px;">
            <a-icon type="exclamation-circle" />
            <span v-if="selectedRowKeys.length > 0">
              此操作将从外部数据源同步选中医师的最新华歧系数，覆盖现有数据（注：未选择数据将同步全部数据）
            </span>
            <span v-else>
              此操作将从外部数据源同步所有医师的最新华歧系数，覆盖现有数据（注：未选择数据将同步全部数据）
            </span>
          </p>
        </div>
      </a-modal>

      <!-- 引入名校设置抽屉组件 -->
      <create-famous-school-form ref="createFamousSchoolForm" @ok="getList" />

      <!-- 引入名医荣誉设置抽屉组件 -->
      <create-doctor-honor-form ref="createDoctorHonorForm" @ok="getList" />

      <!-- 新增：华歧系数详情抽屉组件 -->
      <a-drawer
        title="华歧系数详情"
        placement="right"
        :width="600"
        :visible="scoreDetailVisible"
        :closable="true"
        @close="handleScoreDetailClose"
        destroyOnClose="true"
      >
        <div v-if="currentScoreDetail" class="score-detail-container">
          <a-descriptions :column="2" bordered size="middle">
            <!-- 职称相关 -->
            <a-descriptions-item label="主任/教授职称分值">
              {{ formatDecimal(currentScoreDetail.directorOrProfessor) }}
            </a-descriptions-item>
            <a-descriptions-item label="副主任/副教授职称分值">
              {{ formatDecimal(currentScoreDetail.deputyOrAssociate) }}
            </a-descriptions-item>
            <a-descriptions-item label="主治医师职称分值">
              {{ formatDecimal(currentScoreDetail.attendingPhysician) }}
            </a-descriptions-item>
            <a-descriptions-item label="医师职称分值">
              {{ formatDecimal(currentScoreDetail.physician) }}
            </a-descriptions-item>

            <!-- 简介关键字相关 -->
            <a-descriptions-item label="主任/副主任委员关键字分值">
              {{ formatDecimal(currentScoreDetail.chairViceChair) }}
            </a-descriptions-item>
            <a-descriptions-item label="常委/常务委员关键字分值">
              {{ formatDecimal(currentScoreDetail.standCommitteeMember) }}
            </a-descriptions-item>
            <a-descriptions-item label="委员关键字分值">
              {{ formatDecimal(currentScoreDetail.committeeMember) }}
            </a-descriptions-item>
            <a-descriptions-item label="医生工龄分值">
              {{ formatDecimal(currentScoreDetail.workYears) }}
            </a-descriptions-item>

            <!-- 荣誉相关 -->
            <a-descriptions-item label="国家级荣誉分值">
              {{ formatDecimal(currentScoreDetail.nationalHonor) }}
            </a-descriptions-item>
            <a-descriptions-item label="省级荣誉分值">
              {{ formatDecimal(currentScoreDetail.provinceHonor) }}
            </a-descriptions-item>

            <!-- 基础信息相关 -->
            <a-descriptions-item label="医师注册分值">
              {{ formatDecimal(currentScoreDetail.doctorRegister) }}
            </a-descriptions-item>
            <a-descriptions-item label="基础分">
              {{ formatDecimal(currentScoreDetail.doctorBasic) }}
            </a-descriptions-item>
            <a-descriptions-item label="科室基础分">
              {{ formatDecimal(currentScoreDetail.doctorDepartmentBasic) }}
            </a-descriptions-item>

            <!-- 医院推荐相关 -->
            <a-descriptions-item label="三级医院推荐分值">
              {{ formatDecimal(currentScoreDetail.thirdHospitalRec) }}
            </a-descriptions-item>
            <a-descriptions-item label="二级医院推荐分值">
              {{ formatDecimal(currentScoreDetail.secondHospitalRec) }}
            </a-descriptions-item>
            <a-descriptions-item label="医院推荐本院顶级医师">
              {{ formatDecimal(currentScoreDetail.firstHospitalRec) }}
            </a-descriptions-item>
            <!-- 科室推荐相关 -->
            <a-descriptions-item label="三级医院科室推荐分值">
              {{ formatDecimal(currentScoreDetail.thirdDepartRec) }}
            </a-descriptions-item>
            <a-descriptions-item label="二级医院科室推荐分值">
              {{ formatDecimal(currentScoreDetail.secondDepartRec) }}
            </a-descriptions-item>
            <a-descriptions-item label="科室推荐本科顶级医师">
              {{ formatDecimal(currentScoreDetail.firstDepartRec) }}
            </a-descriptions-item>
            <!-- 医师推荐相关 -->
            <a-descriptions-item label="医师推荐分值">
              {{ formatDecimal(currentScoreDetail.doctorRec) }}
            </a-descriptions-item>
            <a-descriptions-item label="天医查推荐医师">
              {{ formatDecimal(currentScoreDetail.tycDoctorRec) }}
            </a-descriptions-item>

            <!--            <a-descriptions-item label="医师推荐封顶次数">
              {{ currentScoreDetail.doctorRecMax || 0 }}
            </a-descriptions-item>-->

            <!-- 平台推荐相关 -->
            <!--            <a-descriptions-item label="平台推荐三级医师分值">-->
            <!--              {{ formatDecimal(currentScoreDetail.thirdDoctorRec) }}-->
            <!--            </a-descriptions-item>-->
            <!--            <a-descriptions-item label="平台推荐二级医师分值">-->
            <!--              {{ formatDecimal(currentScoreDetail.secondDoctorRec) }}-->
            <!--            </a-descriptions-item>-->

            <!-- 其他加分项 -->
            <a-descriptions-item label="名校毕业分值">
              {{ formatDecimal(currentScoreDetail.prestigiousSchool) }}
            </a-descriptions-item>
            <a-descriptions-item label="点赞分值">
              {{ formatDecimal(currentScoreDetail.like) }}
            </a-descriptions-item>
            <a-descriptions-item label="转发分值">
              {{ formatDecimal(currentScoreDetail.trans) }}
            </a-descriptions-item>
            <a-descriptions-item label="顶级医师分值">
              {{ formatDecimal(currentScoreDetail.topPhysician) }}
            </a-descriptions-item>
            <a-descriptions-item label="最好医师分值">
              {{ formatDecimal(currentScoreDetail.bestPhysician) }}
            </a-descriptions-item>
            <a-descriptions-item label="特色加减分">
              {{ formatDecimal(currentScoreDetail.addScore) }}
            </a-descriptions-item>
            <!-- 总分展示 -->
            <a-descriptions-item label="华歧系数总分" :span="2">
              <span style="font-size: 16px; font-weight: bold; color: #1890ff;">
                {{ calculateTotalScore() }}
              </span>
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <div v-else class="empty-tip">
          <a-empty description="暂无华歧系数数据" />
        </div>
      </a-drawer>

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 1660 }"
      >
        <!-- 性别显示 -->
        <span slot="sex" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_user_sex']" :value="record.sex" />
        </span>

        <!-- 职称显示 -->
        <span slot="professional" slot-scope="text, record">
          <dict-tag :options="dict.type['doctor_professional']" :value="record.professional" />
        </span>

        <!-- 是否顶级医师开关 -->
        <span slot="isTopDoctor" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleIsTopDoctor(record)"
            @cancel="cancelHandleIsTopDoctor(record)">
            <span slot="title">确认{{ record.isTopDoctor === 1 ? '取消' : '设置' }}{{ record.name }}为顶级医师吗?</span>
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="record.isTopDoctor === 1" />
          </a-popconfirm>
        </span>

        <!-- 是否最好医师开关 -->
        <span slot="isBestDoctor" slot-scope="text, record">
          <a-popconfirm
            ok-text="是"
            cancel-text="否"
            @confirm="confirmHandleIsBestDoctor(record)"
            @cancel="cancelHandleIsBestDoctor(record)">
            <span slot="title">确认{{ record.isBestDoctor === 1 ? '取消' : '设置' }}{{ record.name }}为最好医师吗?</span>
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="record.isBestDoctor === 1" />
          </a-popconfirm>
        </span>

        <!-- 名校毕业信息 -->
        <span slot="famousSchool" slot-scope="text, record">
          {{ record.prestigiousSchoolName || '未设置' }}
        </span>

        <!-- 名医荣誉展示 -->
        <span slot="doctorHonor" slot-scope="text, record">
          <div v-if="record.honorList && record.honorList.length">
            <div v-for="(honor, idx) in record.honorList" :key="idx" class="honor-text">
              {{ honor.honor_name }}（{{ getHonorTypeName(honor.honor_type) }}）
            </div>
          </div>
          <div v-else>未设置</div>
        </span>

        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="logo" slot-scope="text, record">
          <img v-viewer v-if="record.logo" :src="processImageUrl(record.logo)" style="width: 50px; height: 50px;">
        </span>

        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['doctor:doctor:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['doctor:doctor:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['doctor:doctor:remove']">
            <a-icon type="delete" />删除
          </a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link" href="#">
              更多 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
<!--              <a-menu-item v-hasPermi="['doctor:doctor:recommend']">-->
<!--                <a @click="recommend(record)">-->
<!--                  <a-icon type="star" />推荐-->
<!--                </a>-->
<!--              </a-menu-item>-->
              <a-menu-item v-hasPermi="['doctor:doctor:score']">
                <a @click="handleScoreAdjust(record)">
                  <a-icon type="calculator" />加减分
                </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['doctor:doctor:famousSchool']">
                <a @click="$refs.createFamousSchoolForm.handleFamousSchool(record)">
                  <a-icon type="school" />设置名校
                </a>
              </a-menu-item>
<!--              <a-menu-item v-hasPermi="['doctor:doctor:honor']">-->
<!--                <a @click="$refs.createDoctorHonorForm.handleDoctorHonor(record)">-->
<!--                  <a-icon type="trophy" />设置荣誉-->
<!--                </a>-->
<!--              </a-menu-item>-->
              <a-menu-item v-hasPermi="['doctor:doctor:scoreDetail']">
                <a @click="handleScoreDetail(record)">
                  <a-icon type="file-text" />华歧系数详情
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import {
  pageDoctor, delDoctor, importDoctor, recommend,
  changeDoctorTopStatus, changeDoctorBestStatus, adjustDoctorScore,
  syncDoctorScore, getDoctorScoreDetail // 新增：获取华歧系数详情接口
} from '@/api/doctor/doctor'
import { pageHospital } from '@/api/hospital/hospital'
import CreateForm from './modules/CreateForm'
import CreateFamousSchoolForm from './modules/CreateFamousSchoolForm'
import CreateDoctorHonorForm from './modules/CreateDoctorHonorForm'
import TableSelectModal from '@/components/TableSelectModal'
import { tableMixin } from '@/store/table-mixin'
import { processImageUrl } from '@/utils/util'
import { getProvinceList, getCityListByProvinceId } from '@/api/system/area'
import moment from 'moment'

export default {
  name: 'Doctor',
  components: {
    CreateForm,
    CreateFamousSchoolForm,
    CreateDoctorHonorForm,
    TableSelectModal
  },
  mixins: [tableMixin],
  dicts: ['sys_user_sex', 'doctor_professional'],
  data () {
    return {
      hospitalSelectVisible: false,
      list: [],
      selectedRowKeys: [], // 选中的医师ID列表
      selectedRows: [],
      advanced: false,
      fileList: [],
      single: true,
      uploading: false,
      openUpload: false,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 省份城市相关
      provinceList: [],
      cityList: [],
      queryParam: {
        userId: null,
        doctorAuthId: null,
        hospitalId: null,
        hospitalName: null,
        departId: null,
        departName: null,
        name: null,
        sex: null,
        certify: null,
        logo: null,
        workYear: null,
        professional: null,
        honor: null,
        strongPoint: null,
        content: null,
        certificate: null,
        score: null,
        provinceId: null,
        provinceName: null,
        cityId: null,
        cityName: null,
        pageNum: 1,
        pageSize: 10
      },
      // 同步华歧系数相关
      syncScoreModalVisible: false,
      syncScoreLoading: false,
      columns: [
        {
          title: '姓名',
          dataIndex: 'name',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '职称',
          dataIndex: 'professional',
          width: 120,
          ellipsis: true,
          align: 'center',
          scopedSlots: { customRender: 'professional' }
        },
        {
          title: '所属医院',
          dataIndex: 'hospitalName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '所属科室',
          dataIndex: 'departName',
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '性别',
        //   dataIndex: 'sex',
        //   width: 80,
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'sex' }
        // },
        // {
        //   title: '医师形象照片',
        //   dataIndex: 'logo',
        //   width: 120,
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'logo' },
        //   align: 'center'
        // },
        // {
        //   title: '工龄',
        //   dataIndex: 'workYear',
        //   width: 80,
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '获得荣誉',
        //   dataIndex: 'honor',
        //   ellipsis: true,
        //   align: 'center'
        // },
        // {
        //   title: '名医荣誉',
        //   dataIndex: 'honorList',
        //   width: 150,
        //   ellipsis: true,
        //   align: 'center',
        //   scopedSlots: { customRender: 'doctorHonor' }
        // },
        {
          title: '顶级医师',
          dataIndex: 'isTopDoctor',
          width: 100,
          scopedSlots: { customRender: 'isTopDoctor' },
          align: 'center'
        },
        {
          title: '最好医师',
          dataIndex: 'isBestDoctor',
          width: 100,
          scopedSlots: { customRender: 'isBestDoctor' },
          align: 'center'
        },
        {
          title: '毕业名校',
          dataIndex: 'prestigiousSchoolName',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'famousSchool' },
          align: 'center'
        },
        {
          title: '华歧系数',
          dataIndex: 'score',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'createTime',
        //   width: 160,
        //   scopedSlots: { customRender: 'createTime' },
        //   align: 'center'
        // },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 200,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      // 加减分弹窗相关
      scoreModalVisible: false,
      scoreLoading: false,
      scoreForm: this.$form.createForm(this),
      currentDoctor: null,
      changeScore: 0,
      scoreValidateStatus: 'success',
      scoreValidateHelp: '正数为加分，负数为减分，0为不调整',
      // 新增：华歧系数详情相关
      scoreDetailVisible: false,
      currentScoreDetail: null
    }
  },
  filters: {
  },
  created () {
    this.getList()
    this.loadProvinceList()
  },
  computed: {
    // 动态生成医院表格列
    hospitalColumns() {
      return [
        {
          title: '医院名称',
          dataIndex: 'hospitalName',
          ellipsis: true,
          width: 200
        },
        {
          title: '地区',
          dataIndex: 'areaName',
          width: 150
        },
        {
          title: '医院等级',
          dataIndex: 'level',
          width: 100
        },
        {
          title: '医院性质',
          dataIndex: 'nature',
          width: 100
        },
        {
          title: '医院类型',
          dataIndex: 'type',
          width: 100
        }
      ]
    }
  },
  watch: {
    'queryParam.provinceId': {
      handler(newVal) {
        if (newVal) {
          this.loadCityList(newVal)
        } else {
          this.cityList = []
          this.queryParam.cityId = null
        }
      }
    }
  },
  methods: {
    pageHospital,
    processImageUrl,

    // 加载省份列表
    loadProvinceList() {
      getProvinceList().then(res => {
        console.log('省份列表响应:', res)
        if (res.code === '20001' && res.data) {
          this.provinceList = res.data.map(item => ({
            id: item.areaId,
            name: item.areaName
          }))
          console.log('省份列表数据:', this.provinceList)
        } else {
          console.error('省份列表加载失败:', res)
        }
      }).catch(err => {
        console.error('省份列表请求异常:', err)
      })
    },

    // 加载城市列表
    loadCityList(provinceId) {
      getCityListByProvinceId(provinceId).then(res => {
        console.log('城市列表响应:', res)
        if (res.code === '20001' && res.data) {
          this.cityList = res.data.map(item => ({
            id: item.areaId,
            name: item.areaName
          }))
          console.log('城市列表数据:', this.cityList)
        } else {
          console.error('城市列表加载失败:', res)
          this.cityList = []
        }
      }).catch(err => {
        console.error('城市列表请求异常:', err)
        this.cityList = []
      })
    },

    // 省份变更处理
    handleProvinceChange(value) {
      this.queryParam.cityId = null
      if (value) {
        this.loadCityList(value)
      } else {
        this.cityList = []
      }
    },

    // 城市变更处理
    handleCityChange(value) {
      // 城市变更逻辑
    },

    // 打开医院选择弹窗
    handleSelectHospital () {
      this.hospitalSelectVisible = true
    },
    // 医院选择确定
    handleHospitalSelected (hospital) {
      this.queryParam.hospitalId = hospital.id
      this.queryParam.hospitalName = hospital.hospitalName
      this.hospitalSelectVisible = false
    },
    // 医院选择取消
    handleHospitalCancel () {
      this.hospitalSelectVisible = false
    },
    // 转换荣誉类型为中文名称
    getHonorTypeName(type) {
      const typeMap = {
        1: '国家级',
        2: '省级',
        3: '市级'
      }
      return typeMap[type] || '未知类型'
    },

    // 新增：格式化小数显示（空值显示0，保留2位小数）
    formatDecimal(value) {
      if (value === null || value === undefined) {
        return '0.00'
      }
      return Number(value).toFixed(2)
    },

    // 新增：计算华歧系数总分
    calculateTotalScore() {
      if (!this.currentScoreDetail) return '0.00'

      const {
        directorOrProfessor, deputyOrAssociate, attendingPhysician, physician,
        chairViceChair, standCommitteeMember, committeeMember, workYears,
        nationalHonor, provinceHonor, doctorRegister, doctorBasic, doctorDepartmentBasic,
        thirdHospitalRec, secondHospitalRec, thirdDepartRec, secondDepartRec,
        doctorRec, thirdDoctorRec, secondDoctorRec, prestigiousSchool,
        like, trans, topPhysician, bestPhysician, addScore, firstHospitalRec, firstDepartRec, tycDoctorRec
      } = this.currentScoreDetail

      // 基础分比率转换为实际分值
      const basicScore = (doctorBasic || 0) * 1
      // 科室基础分比率转换为实际分值
      const departmentBasicScore = (doctorDepartmentBasic || 0) * 1

      // 累加所有分值
      const total = [
        directorOrProfessor, deputyOrAssociate, attendingPhysician, physician,
        chairViceChair, standCommitteeMember, committeeMember, workYears,
        nationalHonor, provinceHonor, doctorRegister, basicScore, departmentBasicScore,
        thirdHospitalRec, secondHospitalRec, thirdDepartRec, secondDepartRec,
        doctorRec, thirdDoctorRec, secondDoctorRec, prestigiousSchool,
        like, trans, topPhysician, bestPhysician, addScore, firstHospitalRec, firstDepartRec, tycDoctorRec
      ].reduce((sum, val) => sum + (Number(val) || 0), 0)

      return total.toFixed(2)
    },

    recommend(record) {
      recommend(record).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.getList()
        } else {
          this.$message.error(res.message)
        }
      })
    },

    beforeUpload(file) {
      this.fileList = [file]
      return false
    },

    importTemplate() {
      this.download(
        'doctor/doctor/importTemplate',
        {},
        `doctor_${moment(new Date()).format('YYYYMMDDHHmm')}.xlsx`
      )
    },

    importExcelHandleChange() {
      this.uploading = true
      const { fileList } = this
      const formData = new FormData()
      formData.append('file', fileList[0])
      importDoctor(formData)
        .then((response) => {
          if (response.success) {
            this.fileList = []
            this.$message.success(response.message)
            this.openUpload = false
            this.$emit('ok', response.data)
            this.getList()
          } else {
            this.$message.error(response.message)
          }
        })
        .finally(() => {
          this.uploading = false
        })
    },

    handleImport() {
      this.title = '导入'
      this.openUpload = true
    },

    handleRemove() {
      this.fileList = []
      this.uploading = false
    },
    importExcelHandleCancel(e) {
      this.openUpload = false
      this.fileList = []
      this.$emit('ok')
    },

    /** 查询医师信息列表 */
    getList () {
      this.loading = true
      pageDoctor(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        doctorAuthId: undefined,
        hospitalId: undefined,
        hospitalName: undefined,
        departId: undefined,
        departName: undefined,
        name: undefined,
        sex: undefined,
        certify: undefined,
        logo: undefined,
        workYear: undefined,
        professional: undefined,
        honor: undefined,
        strongPoint: undefined,
        content: undefined,
        certificate: undefined,
        score: undefined,
        provinceId: undefined,
        provinceName: undefined,
        cityId: undefined,
        cityName: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.cityList = []
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          const data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delDoctor(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
            })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('doctor/doctor/export', {
            ...that.queryParam
          }, `医师信息_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },

    // ========== 加减分相关方法 ==========
    handleScoreAdjust(record) {
      this.changeScore = 0
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
      this.currentDoctor = { ...record }
      this.scoreModalVisible = true
    },

    handleScoreModalCancel() {
      this.scoreModalVisible = false
      this.currentDoctor = null
      this.scoreValidateStatus = 'success'
      this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
    },

    handleScoreInputChange() {
      this.validateScore()
    },

    validateScore() {
      const currentScore = this.currentDoctor?.score || 0
      const adjustScore = this.changeScore || 0
      const finalScore = currentScore + adjustScore

      if (finalScore < 0) {
        this.scoreValidateStatus = 'error'
        this.scoreValidateHelp = `减分值不能超过当前总分(${currentScore})，最多可减${currentScore}分`
        return false
      } else if (adjustScore === 0) {
        this.scoreValidateStatus = 'warning'
        this.scoreValidateHelp = '调整分值不能为0，请输入有效的调整分值'
        return false
      } else {
        this.scoreValidateStatus = 'success'
        this.scoreValidateHelp = '正数为加分，负数为减分，0为不调整'
        return true
      }
    },

    handleScoreModalOk() {
      const isValid = this.validateScore()

      if (!isValid) {
        if (this.changeScore === 0) {
          this.$message.warning('调整分值不能为0，请输入有效的调整分值')
        } else if ((this.currentDoctor?.score || 0) + (this.changeScore || 0) < 0) {
          this.$message.error(`减分值不能超过当前总分(${this.currentDoctor?.score || 0})，最多可减${this.currentDoctor?.score || 0}分`)
        }
        return
      }

      this.scoreLoading = true

      adjustDoctorScore(this.currentDoctor.id, this.changeScore)
        .then((res) => {
          if (res.success) {
            this.$message.success('分值调整成功')
            this.scoreModalVisible = false
            this.getList()
            this.changeScore = 0
          } else {
            this.$message.error(`分值调整失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('分值调整异常，请稍后重试')
        })
        .finally(() => {
          this.scoreLoading = false
        })
    },

    // ========== 是否顶级医师状态修改 ==========
    confirmHandleIsTopDoctor(row) {
      const oldStatus = row.isTopDoctor
      const newStatus = row.isTopDoctor === 1 ? 0 : 1
      const text = newStatus === 1 ? '设置' : '取消'

      changeDoctorTopStatus(row.id, newStatus)
        .then((res) => {
          if (res.success) {
            row.isTopDoctor = newStatus
            this.$message.success(`${text}顶级医师成功`, 3)
          } else {
            row.isTopDoctor = oldStatus
            this.$message.error(`${text}顶级医师失败: ${res.message}`, 3)
          }
        }).catch(() => {
        row.isTopDoctor = oldStatus
        this.$message.error(`${text}顶级医师异常`, 3)
      })
    },
    cancelHandleIsTopDoctor(row) {
      // 取消操作，无需处理
    },

    // ========== 是否最好医师状态修改 ==========
    confirmHandleIsBestDoctor(row) {
      const oldStatus = row.isBestDoctor
      const newStatus = row.isBestDoctor === 1 ? 0 : 1
      const text = newStatus === 1 ? '设置' : '取消'

      changeDoctorBestStatus(row.id, newStatus)
        .then((res) => {
          if (res.success) {
            row.isBestDoctor = newStatus
            this.$message.success(`${text}最好医师成功`, 3)
          } else {
            row.isBestDoctor = oldStatus
            this.$message.error(`${text}最好医师失败: ${res.message}`, 3)
          }
        }).catch(() => {
        row.isBestDoctor = oldStatus
        this.$message.error(`${text}最好医师异常`, 3)
      })
    },
    cancelHandleIsBestDoctor(row) {
      // 取消操作，无需处理
    },

    // ========== 同步华歧系数相关方法 ==========
    /**
     * 打开同步华歧系数确认弹窗
     */
    handleSyncScore() {
      this.syncScoreModalVisible = true
    },

    /**
     * 取消同步华歧系数（关闭弹窗）
     */
    handleSyncScoreCancel() {
      this.syncScoreModalVisible = false
      this.syncScoreLoading = false
    },

    /**
     * 确认同步华歧系数
     * - 无选中ID → 同步全部
     * - 有选中ID → 仅同步选中的医师
     */
    handleSyncScoreConfirm() {
      this.syncScoreLoading = true

      // 构建请求参数
      let syncParams = []
      // 如果有选中的医师ID，转换为[{"id":xxx}]数组
      if (this.selectedRowKeys.length > 0) {
        syncParams = this.selectedRowKeys.map(id => ({ id: id }))
      }

      // 调用同步医师华歧系数接口
      syncDoctorScore(syncParams)
        .then((res) => {
          if (res.success) {
            // 根据选中状态显示不同的成功提示
            if (this.selectedRowKeys.length > 0) {
              this.$message.success(`已成功同步选中的 ${this.selectedRowKeys.length} 位医师华歧系数`)
            } else {
              this.$message.success('已成功同步所有医师华歧系数')
            }
            this.syncScoreModalVisible = false
            // 刷新列表，展示最新的华歧系数
            this.getList()
          } else {
            this.$message.error(`医师华歧系数同步失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.$message.error('医师华歧系数同步异常，请稍后重试')
        })
        .finally(() => {
          this.syncScoreLoading = false
        })
    },

    // ========== 新增：华歧系数详情相关方法 ==========
    /**
     * 打开华歧系数详情抽屉
     */
    handleScoreDetail(record) {
      this.scoreDetailVisible = true
      // 调用接口获取华歧系数详情
      getDoctorScoreDetail(record.id)
        .then((res) => {
          if (res.success) {
            this.currentScoreDetail = res.data
          } else {
            this.currentScoreDetail = null
            this.$message.error(`获取华歧系数详情失败: ${res.message}`)
          }
        })
        .catch(() => {
          this.currentScoreDetail = null
          this.$message.error('获取华歧系数详情异常，请稍后重试')
        })
    },

    /**
     * 关闭华歧系数详情抽屉
     */
    handleScoreDetailClose() {
      this.scoreDetailVisible = false
      this.currentScoreDetail = null
    }
  }
}
</script>

<style scoped>
/* 名医荣誉文本样式 */
.honor-text {
  font-size: 12px;
  line-height: 1.4;
}

/* 选中数量提示样式 */
.selected-count {
  display: inline-block;
  background: #1890ff;
  color: white;
  font-size: 12px;
  padding: 0 4px;
  border-radius: 8px;
  margin-left: 4px;
}

/* 新增：华歧系数详情样式 */
.score-detail-container {
  padding: 16px 0;
}

.empty-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.ant-descriptions-item-content {
  word-break: break-all;
}
</style>
